import React from "react";

import { MarkSvg } from "../styles";
import { MarkProps } from "../types";

/** Bars and a signal line on a panel — the variant the app ships with. */
const SignalMark = ({ size, ...rest }: MarkProps) => (
  <MarkSvg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest}>
    <rect x="3" y="3" width="34" height="34" rx="8" fill="#633DD1" />
    <rect x="7" y="7" width="26" height="26" rx="5" fill="url(#bo-logo-signal-panel)" />
    <path d="M11 15H29M11 21H29M11 27H29" stroke="#D8CBFF" strokeWidth="1" opacity="0.28" />
    <path d="M13 29V25" stroke="#BFA7FF" strokeWidth="3" strokeLinecap="round" />
    <path d="M18 29V20" stroke="#A77BFF" strokeWidth="3" strokeLinecap="round" />
    <path d="M23 29V17" stroke="#865DFC" strokeWidth="3" strokeLinecap="round" />
    <path d="M28 29V12" stroke="#BA00D9" strokeWidth="3" strokeLinecap="round" />
    <path
      d="M11.5 21.8C15.5 20.9 17 14.8 20.8 16.4C23.8 17.7 24 11.8 29 10.6"
      stroke="#EDEEFA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="bo-logo-signal-panel"
        x1="8"
        y1="8"
        x2="31"
        y2="31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8F63FF" />
        <stop offset="0.5" stopColor="#7748FC" />
        <stop offset="1" stopColor="#2E0083" />
      </linearGradient>
    </defs>
  </MarkSvg>
);

export default SignalMark;
